import React, { useState, useEffect } from "react";
import { Row, Col } from "react-bootstrap";
import { Button, DatePicker } from "../../Common";
import styles from "./Customer.module.css";
import { updateCustomer } from "../../api";
import CommentModal from "../../Common/CommentModal/commentModal";
import "react-datepicker/dist/react-datepicker.css";
import DropDown from "../../Common/DropDown/index";
import Modal from "../../Common/ClosureModal/Modal";
import Input from "../../Common/V2/Widgets/Input";

  const PersonalDetail = ({ data, isEditable, refreshDetails, listStatus, countryOptions = [] }) => {
  const [isEdit, setIsEdit] = useState(false);
  const [dob, setDob] = useState(data.dob ? new Date(data.dob) : "");
  const [politicallyExposedNames, setPoliticallyExposedNames] = useState(
    data.politicallyExposedNames
  );
  const [gender, setGender] = useState(data.gender);
  const [state, setState] = useState(data.state);
  const [city, setCity] = useState(data.city);
  const [postalCode, setPostalCode] = useState(data.postalCode);
  const [country, setCountry] = useState(data.country);
  const [address1, setAddress1] = useState(data.address1);
  const [address2, setAddress2] = useState(data.address2);
  const [loading, setLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isComment, setIsComment] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [comment, setComment] = useState("");
  const [isCountryWarningOpen, setIsCountryWarningOpen] = useState(false);
  const [countryChanged, setCountryChanged] = useState(false);
  const [error, setError] = useState("");
  const genderList = ["Male", "Female"];

  const updateCustomerDetail = async (custId, comment) => {
    if (loading) return;
    setLoading(true);
    const data = {
      comment: isComment,
      politicallyExposedNames: politicallyExposedNames,
      dob: formatDate(dob),
      gender: gender,
      state: state,
      city: city,
      country: country,
      postalCode: postalCode,
      address1: address1,
      address2: address2,
    };
    const currentDobFormatted = formatDate(dob);
    const originalDobFormatted = formatDate(data.dob);

    if (currentDobFormatted !== originalDobFormatted) {
      data.dob = currentDobFormatted;
    }
    try {
      const resp = await updateCustomer(custId, data);
      if (resp?.code === 200) {
        setIsEdit(false);
        setSuccessMessage("Details updated successfully!");
        await refreshDetails();
        setErrorMessage("");
        setTimeout(() => {
          setSuccessMessage("");
          setIsModalOpen(false);
        }, 3000);
      } else {
        setSuccessMessage("");
        setError("");
        setComment("");
        setErrorMessage(resp?.data?.message || "Something went wrong");
        setTimeout(() => {
          setIsModalOpen(false);
        }, 3000);
      }
    } catch (error) {
      setSuccessMessage("");
      setError("");
      setComment("");
      setErrorMessage(
        error?.response?.data?.message || "Failed to update details"
      );
      setTimeout(() => {
        setIsModalOpen(false);
      }, 3000);
    } finally {
      setLoading(false);
    }
  };

    const selectedCountry = countryOptions.find((opt) => opt.value === country) || {};
    const countryNames = countryOptions.map((opt) => opt.label);
    const handleCountryChange = (selectedName) => {
    const selected = countryOptions.find((opt) => opt.label === selectedName);
    const newValue = selected ? selected.value : "";
    setCountry(newValue);
    if (newValue !== data.country) {
      setCountryChanged(true);
    } else {
      setCountryChanged(false);
    }
  };
  const formatDate = (date) => {
    if (!date) return "";
    try {
      if (!(date instanceof Date)) {
        date = new Date(date);
      }
      return date.toISOString().split("T")[0];
    } catch (e) {
      return "";
    }
  };
  const initialData = {
    politicallyExposedNames: data?.politicallyExposedNames || "",
    dob: data?.dob ? new Date(data.dob) : "",
    gender: data?.gender,
    state: data?.state || "",
    city: data?.city || "",
    country: data?.country || "",
    postalCode: data?.postalCode || "",
    address1: data?.address1 || "",
    address2: data?.address2 || "",
  };

  const handleBackButton = () => {
    setPoliticallyExposedNames(initialData.politicallyExposedNames);
    setDob(initialData.dob);
    setGender(initialData.gender);
    setState(initialData.state);
    setCity(initialData.city);
    setCountry(initialData.country);
    setPostalCode(initialData.postalCode);
    setAddress1(initialData.address1);
    setAddress2(initialData.address2);
    setIsEdit(false);
  };
  const handleSavebutton = () => {
    if (countryChanged) {
      setIsCountryWarningOpen(true);
    } else {
      setIsModalOpen(true);
      setErrorMessage("");
      setError("");
      setSuccessMessage("");
      setComment("");
    }
  };

  const handleToggleModal = () => {
    setIsModalOpen(false);
  };
  return (
    <div style={{ marginTop: "30px" }}>
      <Row className={styles.detailContainer}>
        <Col className="p-0">Personal Detail</Col>
        {isEditable &&
        listStatus !== "CLOSED" &&
        data?.accountStatus !== "CLOSED" ? (
          <Col
            md={2}
            onClick={() => setIsEdit(true)}
            style={{
              cursor: "pointer",
              display: "flex",
              justifyContent: "end",
            }}
          >
            <div style={{ width: "max-content" }}>
              {isEdit ? (
                <div style={{ display: "flex", flexDirection: "row" }}>
                  <Button
                    title="Save"
                    disabled={loading}
                    margin={"0px 10px"}
                    onClick={handleSavebutton}
                  />
                  <Button
                    title="Back"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleBackButton();
                    }}
                  />
                </div>
              ) : (
                "Edit"
              )}
            </div>
          </Col>
        ) : (
          ""
        )}
      </Row>
      {isEdit ? (
        <>
          <Row style={{ marginTop: 10 }}>
            <Col className={styles.text}>
              <div className={styles.date + " " + "dateHeight"}>
                <span className={styles.dobTittle}>Dob</span>
                <DatePicker
                  selected={dob}
                  onChange={(date) => setDob(date)}
                  dateFormat="yyyy-MM-dd"
                  className={styles.datePicker}
                  placeholderText="Select Date of Birth"
                  showMonthDropdown
                  showYearDropdown
                  dropdownMode="select"
                />
              </div>
            </Col>
            <Col className={styles.text}>
              <Input
                label={"Political Exposed Names"}
                value={politicallyExposedNames}
                onChange={(e) => setPoliticallyExposedNames(e.target.value)}
              />
            </Col>
            <Col className={styles.text}>
              <DropDown
                label="Gender"
                name="gender"
                value={gender}
                data={genderList}
                onChange={(val) => setGender(val)}
                placeholder="Select Gender"
                required={false}
              />
            </Col>
          </Row>
          <Row style={{ marginTop: 10 }}>
            <Col className={styles.text}>
              <DropDown
                label="Country"
                name="country"
                value={selectedCountry.label}
                data={countryNames}
                onChange={handleCountryChange}
                placeholder="Select Country"
              />
            </Col>
            <Col className={styles.text}>
              <Input
                label={"State"}
                value={state}
                onChange={(e) => setState(e.target.value)}
              />
            </Col>
            <Col className={styles.text}>
              <Input
                label={"City"}
                value={city}
                onChange={(e) => setCity(e.target.value)}
              />
            </Col>
          </Row>
          <Row style={{ marginTop: 10 }}>
            <Col className={styles.text}>
             <Input
                label={"Postal Code"}
                value={postalCode}
                onChange={(e) => setPostalCode(e.target.value)}
              />
            </Col>
            <Col className={styles.text}>
              <Input
                label={"Address 1"}
                value={address1}
                onChange={(e) => setAddress1(e.target.value)}
              />
            </Col>
            <Col className={styles.text}>
              <Input
                label={"Address 2"}
                value={address2}
                onChange={(e) => setAddress2(e.target.value)}
              />
            </Col>
          </Row>
        </>
      ) : (
        <>
          <Row style={{ marginTop: 10 }}>
            <Col className={styles.text}>Dob : {formatDate(dob) || "--"}</Col>
            <Col className={styles.text}>
              Politically Exposed Name: {politicallyExposedNames || "--"}
            </Col>
            <Col className={styles.text}>Gender : {gender || "--"}</Col>
          </Row>
          <Row style={{ marginTop: 10 }}>
            <Col className={styles.text}>
              Country :{" "}
              {countryOptions.find((opt) => opt.value === country)?.label ||
                "--"}
            </Col>
            <Col className={styles.text}>State : {state || "--"}</Col>
            <Col className={styles.text}>City : {city || "--"}</Col>
          </Row>
          <Row style={{ marginTop: 10 }}>
            <Col className={styles.text}>
              Postal Code : {postalCode || "--"}
            </Col>
            <Col className={styles.text}>Address 1 : {address1 || "--"}</Col>
            <Col className={styles.text}>Address 2 : {address2 || "--"}</Col>
          </Row>
        </>
      )}
      <Modal
        isOpen={isCountryWarningOpen}
        onRequestClose={() => setIsCountryWarningOpen(false)}
        title="Warning"
        description="Country is linked to partner, plan, address and national ID settings. Review related configurations after update."
        onYes={() => {
          setIsCountryWarningOpen(false);
          setIsModalOpen(true);
          setErrorMessage("");
          setError("");
          setSuccessMessage("");
          setComment("");
        }}
        onNo={() => setIsCountryWarningOpen(false)}
        yesLabel="Continue"
        noLabel="Cancel"
        showIcon={true}
      />
      <CommentModal
        setIsComment={setIsComment}
        isOpen={isModalOpen}
        onRequestClose={handleToggleModal}
        successMessage={successMessage}
        setSuccessMessage={setSuccessMessage}
        errorMessage={errorMessage}
        error={error}
        setError={setError}
        comment={comment}
        setComment={setComment}
        onSave={() => updateCustomerDetail(data.customerId)}
        loading={loading}
      />
    </div>
  );
};

export default PersonalDetail;
